<template>
  <div>
    <el-form
      :model="queryParams"
      :rules="rules"
      ref="formInfo"
      style="margin-bottom: 0; background-color: #fff; padding: 20px"
      label-width="140px"
    >
      <div class="metaInfo">
        <p>数据唯一编号</p>
        <el-form-item label="实体编号：" prop="superIndividualId">
          <el-input v-model="queryParams.superId" placeholder="请输入" />
        </el-form-item>
      </div>
      <div class="metaInfo">
        <p>数据来源信息</p>
        <el-form-item label="数据来源类型：" prop="souceDataType">
          <el-checkbox-group v-model="queryParams.checkedSources">
            <el-checkbox
              v-for="source in dataSources"
              :key="source.value"
              :label="source.value"
            >
              {{ source.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="数据来源：" prop="souceData">
          <el-input
            type="textarea"
            v-model="queryParams.souceData"
            placeholder="请输入"
            rows="2"
            show-word-limit
            maxlength="50"
          />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
// utils
import { debounce } from "@/utils/index.js";

export default {
  name: "EnterpriseInfo",
  components: {},
  data() {
    return {
      queryParams: {
        superId: "",
        souceData: "",
        checkedSources: [],
      },
      isInit: false,
      rules: {
        superIndividualId: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
      },
      dataSources: [
        { label: "第三方采集", value: "0" },
        {
          label: "自动爬取",
          value: "1",
        },
        {
          label: "文档解析",
          value: "2",
        },
        { label: "人工录入", value: "3" },
        { label: "其他类型", value: "4" },
      ],
    };
  },
  created() {},
  methods: {
    submit() {
      this.$refs.formInfo.validate((valid) => {
        if (valid) {
          console.log("表单数据:", this.form);
          this.$message.success("提交成功！");
        } else {
          this.$message.error("请检查表单填写是否正确");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .company_left {
    display: flex;
    .info {
      margin-left: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .fullName {
        display: flex;
        align-items: center;
        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #7c7f8e;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
  .company_right {
    font-size: 12px;
    color: #7c7f8e;
  }
}
/deep/ .el-tabs__content {
  overflow: auto;
}
.companyInfo {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
  .avatar {
    margin-right: 20px;
  }
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  .el-button {
    margin: 0 20px;
  }
}
.leave {
  width: 426px !important;
  height: 84px !important;
  padding: 10px 0;
  background: #f5f6f7;
}
::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-textarea {
  width: 470px;
}
p {
  color: #333;
  font-size: 18px;
  font-weight: bold;
}
.metaInfo {
  border-bottom: 20px solid #d8efff;
  margin-bottom: 20px;
}
.metaInfo:last-child {
  border: none;
}
</style>
